var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E09F0D;}\n\t.st1{fill:#243193;}\n\t.st2{fill:#BCC0D8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,354.9c-7.8,0-14.2-6.4-14.2-14.2v-56c0-7.8,6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2v56 C270.2,348.6,263.8,354.9,256,354.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,327h-56c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2h56c7.8,0,14.2,6.4,14.2,14.2S291.8,327,284,327z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,405.7c-51.3,0-93-41.7-93-93s41.7-93,93-93c15.7,0,31.1,4,44.8,11.5c6.9,3.8,9.4,12.4,5.6,19.3 s-12.4,9.4-19.3,5.6c-9.5-5.2-20.2-8-31.1-8c-35.6,0-64.6,29-64.6,64.6s29,64.6,64.6,64.6s64.6-29,64.6-64.6 c0-7.8,6.4-14.2,14.2-14.2s14.2,6.4,14.2,14.2C349,364,307.3,405.7,256,405.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M497.8,173.4H14.2C6.4,173.4,0,167,0,159.2v-95c0-25.5,20.8-46.3,46.3-46.3h85.9c17.5,0,33.4,9.7,41.3,25.3 l13.2,26h279c25.5,0,46.3,20.8,46.3,46.3v43.6C512,167,505.6,173.4,497.8,173.4z M28.4,145h455.2v-29.4c0-9.9-8-17.9-17.9-17.9H178 c-5.3,0-10.2-3-12.7-7.8l-17.2-33.8c-3.1-6.1-9.2-9.8-16-9.8H46.3c-9.9,0-17.9,8.1-17.9,17.9V145z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.2,494.1H59.8c-33,0-59.8-26.8-59.8-59.8V159.2c0-7.8,6.4-14.2,14.2-14.2h483.6c7.8,0,14.2,6.4,14.2,14.2 v154.7c0,7.8-6.4,14.2-14.2,14.2s-14.2-6.4-14.2-14.2V173.4H28.4v260.9c0,17.3,14.1,31.4,31.4,31.4h392.3 c17.3,0,31.4-14.1,31.4-31.4V397c0-7.8,6.4-14.2,14.2-14.2S512,389.2,512,397v37.2C512,467.2,485.2,494.1,452.2,494.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.e047b776ed70cf658198a1ee0405335d.svg";
export { ForwardRef as ReactComponent };